const getVersion = () => {
  return process.env.NEXT_PUBLIC_MYSTES_VERSION ?? "stable"
}

export default getVersion